import { getDOB } from 'src/consumer/helpers/profilePageHelper'

export const prepareDataForRegistration = (data) => {
  const registrationData = {
    userName: data?.email,
    email: data?.email,
    password: data?.password,
  }

  let lat = null
  let lng = null
  try {
    const geoLocationString = localStorage.getItem('geoLocation')
    if (geoLocationString) {
      const geoLocation = JSON.parse(geoLocationString)
      if (geoLocation) {
        lat = geoLocation.lat
        lng = geoLocation.lng
      }
    }
  } catch (error) {
    console.error('Error parsing geoLocation from localStorage:', error)
  }

  const countryCode = localStorage.getItem('countryCode') || null

  const locationObject = {}

  if (lat !== null) locationObject['lat'] = lat
  if (lng !== null) locationObject['lng'] = lng
  if (countryCode) locationObject['countryCode'] = countryCode

  registrationData['location'] = locationObject

  const acquisitionReference = {}

  const acquisitionReferenceRefId = sessionStorage.getItem('acquisitionReferenceRefId')
  const acquisitionReferenceRefType = sessionStorage.getItem('acquisitionReferenceRefType')

  if (acquisitionReferenceRefId) {
    acquisitionReference['refId'] = acquisitionReferenceRefId
  }
  if (acquisitionReferenceRefType) {
    acquisitionReference['refType'] = acquisitionReferenceRefType
  }

  if (Object.keys(acquisitionReference).length > 0) {
    registrationData['acquisitionReference'] = acquisitionReference
  }

  return registrationData
}

/**
 * Build the /api/secure/user/update body for the basic-onboarding fields. The endpoint
 * replaces the whole document, so everything already on the profile is carried over:
 * personalize sub-objects (persona, acquisition, preferences) are merged, not replaced, and
 * a typed "First Last" is split so an already-stored last name is not doubled up.
 */
export const prepareDataForUpdate = (data, profileData) => {
  const typedName = String(data?.name || '').trim()
  const nameParts = typedName.split(/\s+/).filter(Boolean)
  const firstName = nameParts[0] || typedName
  const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : profileData?.lastName || ''
  const existingPersonalize = profileData?.personalize || {}
  const existingStudent = existingPersonalize?.studentPersonalize || {}
  const contentLanguages =
    Array.isArray(data?.contentLanguages) && data.contentLanguages.filter(Boolean).length > 0
      ? data.contentLanguages.filter(Boolean)
      : Array.isArray(existingStudent?.contentLanguages) && existingStudent.contentLanguages.length > 0
      ? existingStudent.contentLanguages
      : ['en']

  return {
    ...profileData,
    firstName,
    lastName,
    gender: data?.gender,
    dob: getDOB(data?.age),
    personalize: {
      ...existingPersonalize,
      studentPersonalize: {
        ...existingStudent,
        contentLanguages,
      },
    },
  }
}

export const prepareDataForPersonalize = (data, profileData) => {
  let studentPersonalizeObject = profileData.personalize.studentPersonalize

  return {
    ...studentPersonalizeObject,
    acquisitionId: data?.acquisitionMethod,
    primaryPath: data?.pathSelected,
    mentalHealthProfessional: {
      ...studentPersonalizeObject?.mentalHealthProfessional,
      iamMentalHealthProfessional: data?.wantProfessional === 'self' ? true : false,
      workingWithMentalHealthProfessional:
        data?.wantProfessional === 'self' ? null : data?.wantProfessional,
    },
    persona: {
      ...studentPersonalizeObject?.persona,
      bodyTopics: [],
      category: data?.categoriesSelected,
      focusAreas: data?.focusAreasSelected,
      mindTopics: [],
      soulTopics: [],
      primaryTopics: [],
      secondaryTopics: [],
    },
  }
}
